const TableStyle = {
  Compact: 'compact',
  Default: '_default',
};

export default TableStyle;
